import { Component, CUSTOM_ELEMENTS_SCHEMA, EventEmitter, inject, Input, OnInit, Output } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule } from '@angular/forms'
import { IonicModule } from '@ionic/angular'
import { IonicSelectableComponent } from 'ionic-selectable'
import { AssistantDropdownService } from './assistant-dropdown.service'
import { Assistant } from '../../../models/assistant'

@Component({
  selector: 'app-assistant-dropdown',
  standalone: true,
  imports: [CommonModule, FormsModule, IonicModule, IonicSelectableComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './assistant-dropdown.component.html',
  styleUrls: ['./assistant-dropdown.component.scss'],
})
export class AssistantDropdownComponent implements OnInit {
  private service = inject(AssistantDropdownService)

  @Input() title = ''

  @Output() changed = new EventEmitter<Assistant>()

  selectedAssistant: Assistant

  assistants$ = this.service.getAllAssistants()

  ngOnInit(): void {
    this.changed.emit(null)
  }
}
